import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-key-2",
  "use": "icon-si-glyph-key-2-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-si-glyph-key-2\"><g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\"><path d=\"M15.797,1.272 C14.248,-0.278 11.649,-0.378 10.107,1.165 C8.988,2.282 8.79,3.999 9.295,5.398 L1.072,13.621 C1.072,13.621 0.538,16.448 2.922,15.836 C2.98,15.76 3.969,15.25 3.969,15.25 L3.992,12.961 L6.215,13 L6.955,12.125 L6.969,9.953 L8.946,9.953 L8.944,7.978 L11.112,7.97 L11.491,7.712 C12.93,8.314 14.688,7.874 15.812,6.869 C17.438,5.416 17.347,2.821 15.797,1.272 L15.797,1.272 Z M15.016,3.031 L13.969,3.031 L13.969,1.984 L15.016,1.984 L15.016,3.031 L15.016,3.031 Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-key-2.svg
// module id = iQJI
// module chunks = 62